<template>
    <div class="slide-out-panel" :class="{'is-open': isOpen}">
        <div class="panel-overlay" @click="$emit('close')"></div>
        <div class="panel-content" :style="{width: width + 'px'}">
            <div class="panel-header">
                <h3><i v-if="icon" class="fa-fw mr-2" :class="icon"></i>{{ title }}</h3>
                <button class="delete is-medium" @click="$emit('close')"></button>
            </div>

            <div class="panel-body">
                <slot></slot>
            </div>

            <div class="panel-footer" v-if="$slots.footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
// Shared slide-out drawer chrome (overlay, header, scrolling body, footer bar).
// Same look and behavior as the original StudyLogEntryPanel drawer.
export default {
    name: 'SlideOutPanel',
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            default: null
        },
        width: {
            type: Number,
            default: 450
        }
    }
};
</script>

<style lang="scss" scoped>
.slide-out-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s ease;

    &.is-open {
        pointer-events: auto;
        opacity: 1;

        .panel-content {
            transform: translateX(0);
        }
    }

    .panel-overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
    }

    .panel-content {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        max-width: 100%;
        background: white;
        box-shadow: -5px 0 20px rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        transform: translateX(100%);
        transition: transform 0.3s ease;
    }

    .panel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #e5e5e5;
        background: #f8f8f8;

        h3 {
            margin: 0;
            font-size: 1.1rem;
            font-weight: 600;
        }
    }

    .panel-body {
        flex: 1;
        padding: 1.5rem;
        overflow-y: auto;
    }

    .panel-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        border-top: 1px solid #e5e5e5;
        background: #f8f8f8;
    }
}

@media (max-width: 500px) {
    .slide-out-panel .panel-content {
        width: 100% !important;
    }
}
</style>
